import './AboutUsStyles.css'

const AboutUs = () => {

    return (
        <div className={'about-container'}>
        <h1>Our Project</h1>
        <p>StockWise is trying gives a better way to provide guidance for the people who are looking for better financial stability. Currently providing stock market suggestion and have potential to provide windows of opportunity.</p>

        <h1>Aim</h1>
        <p>The goal of the investment app was to make investing more accessible, affordable, and transparent for a wider range of individuals, regardless of their financial literacy or investment experience.</p>

        <h1>Motivation</h1>
        <p>Investing can be intimidating for some people, and developing an app that simplifies the investment process and makes it more accessible can be a motivating factor. By making investing easier and more approachable. addressing a need, capitalizing on a trend, generating revenue, improving accessibility, and enhancing the user experience. By identifying a unique value proposition and catering to the needs of a specific audience, we got motivation create a successful investment app.</p>
    </div>
    )

}

export default AboutUs









